import { useEffect, useState } from 'react'

import favorites_active from '../assets/casino/favorites_active.webp'
import favorites_light from '../assets/casino/favorites_light.webp'
import favorites_off from '../assets/casino/favorites_off.webp'
import { useBoundStore } from '../store/store'
import type { CasinoSlice } from '../store/types/casino'
import { api } from '../utils/api-client'

const useGameCategories = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const setCategories = useBoundStore(state => state.casino.setCategories)
  const categories = useBoundStore(state => state.casino.categories)
  const username = useBoundStore(state => state.user.username)

  useEffect(() => {
    const controller = new AbortController()
    const signal = controller.signal

    if (
      categories.length === 0 ||
      (categories.find(c => c.id === 'recent_played') && !username) ||
      (!categories.find(c => c.id === 'recent_played') && username)
    ) {
      const fetchCategories = async () => {
        setIsLoading(true)

        try {
          const res = await api.get<CasinoSlice['categories']>(
            '/games/categories.php',
            {
              account: username,
            },
            { signal },
          )

          if (res.data) {
            const data = username
              ? [
                  ...res.data,
                  {
                    id: 'favorites',
                    category: 'FAVORITOS',
                    icon_active: favorites_active,
                    icon_light: favorites_light,
                    icon_off: favorites_off,
                    count: 0,
                  },
                ]
              : res.data

            setCategories(data)
          }
        } catch (error) {
          console.error(error)
        } finally {
          setIsLoading(false)
        }
      }

      fetchCategories()

      return () => {
        controller.abort()
      }
    }
  }, [username])

  return {
    categories,
    isLoading,
  }
}

export default useGameCategories
